import { connect } from 'react-redux'
import SharedPreview from './shared-preview'
import {
  fetchSharedPresentation,
  copyPresentation
} from '../../../stores/shared-presentation/shared-presentation.actions'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  getFetchRequest,
  getSharedPresentation
} from '../../../stores/shared-presentation/shared-presentation.selectors'
import { markAsSeen } from '../../../stores/shared-presentations/shared-presentations.actions'

const mapStateToProps = (state, { match }) => {
  const fetchRequest = getFetchRequest(state)
  const sharedPresentation = getSharedPresentation(state)
  return {
    pending:
      !sharedPresentation ||
      sharedPresentation.id !== match.params.id ||
      fetchRequest.pending,
    presentation: !sharedPresentation ? null : sharedPresentation.presentation
  }
}

const mapDispatchToProps = (dispatch, { match, history }) => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClose: () => ownProps.history.push('/shared'),
  onCopy: () =>
    dispatch(copyPresentation(stateProps.presentation.id))
      .then(() => ownProps.history.push('/'))
      .catch(errorHandler),
  onMount: () =>
    dispatch(fetchSharedPresentation(ownProps.match.params.id))
      .catch(errorHandler)
      .then(
        res =>
          !res.data.shared_presentation.seen &&
          dispatch(markAsSeen(ownProps.match.params.id)).catch(errorHandler)
      )
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(SharedPreview)
)
